export default "__VITE_ASSET__BBLEx5P2__"